import dayjs from "dayjs";
import { array, date, number, object, ref, string } from "yup";

import { ChartOfAccountTypeEnum } from "@/features/chart-of-accounts";

// Hutang Beban. Only short-term liabilities can carry an accrued expense.
export const PAYABLE_ACCOUNT_TYPES = [
  ChartOfAccountTypeEnum.CURRENT_LIABILITIES,
];

// The expense side of the document.
export const EXPENSE_ACCOUNT_TYPES = [
  ChartOfAccountTypeEnum.COST_OF_GOODS_SOLD,
  ChartOfAccountTypeEnum.EXPENSES,
  ChartOfAccountTypeEnum.OTHER_EXPENSES,
];

export const DEFAULT_VALUES = {
  transactionDate: dayjs(),
  dueDate: dayjs(),
  expensePayableOutletChartOfAccount: null,
  note: "",
  expenseAccrualDetails: [],
};

export const VALIDATION_SCHEMA = object().shape({
  transactionDate: date()
    .typeError("Tanggal tidak valid")
    .required("Harus diisi"),
  dueDate: date()
    .typeError("Tanggal tidak valid")
    .required("Harus diisi")
    .min(ref("transactionDate"), "Tidak boleh sebelum tanggal transaksi"),
  expensePayableOutletChartOfAccount: object()
    .nullable()
    .required("Harus diisi"),
  note: string().nullable(),
  expenseAccrualDetails: array()
    .min(1, "Harus memiliki setidaknya satu baris")
    .of(
      object().shape({
        outletChartOfAccount: object().nullable().required("Harus diisi"),
        amount: number()
          .transform((value, originalValue) =>
            originalValue === "" ? undefined : value
          )
          .typeError("Harus berupa angka")
          .required("Harus diisi")
          .moreThan(0, "Harus lebih dari 0"),
        note: string().nullable(),
      })
    ),
});
